import { backendUrl } from "./url-builder";
import Toaster, { toastIcons } from "../components/Page/components/Toaster";
import { Intent } from "@blueprintjs/core";
export var ErrorType;
(function (ErrorType) {
    ErrorType["Unknown"] = "Unknown";
    ErrorType["Validation"] = "Validation";
    ErrorType["Internal"] = "Internal";
    ErrorType["NotFound"] = "NotFound";
    ErrorType["AlreadyExist"] = "AlreadyExist";
    ErrorType["Forbidden"] = "Forbidden";
    ErrorType["Timeout"] = "Timeout";
    ErrorType["ExpiredLicense"] = "ExpiredLicense";
    ErrorType["DependentWorkspacesChanged"] = "DependentWorkspacesChanged";
    ErrorType["InternalEngine"] = "InternalEngine";
})(ErrorType || (ErrorType = {}));
export const NO_ACCESS_MESSAGE = "You don't have access to subscribe element.";
export const ERROR_CODE_BAD_REQUEST = 400;
export const ERROR_CODE_CONFLICT = 409;
export const ERROR_CODE_NOT_FOUND = 404;
export const ERROR_FORBIDDEN = 403;
export const INTERNAL_SERVER_ERROR_CODE = 500;
const ERROR_NETWORK_MESSAGE = `Network Error. Please check your backend host:\n ${backendUrl}`;
const showToaster = (errorMessage) => {
    Toaster().show({
        timeout: 7000,
        message: errorMessage,
        intent: Intent.DANGER,
        icon: toastIcons.error,
    });
};
const handleErrorMessage = (errorMessage) => {
    return errorMessage === "Network Error" ? ERROR_NETWORK_MESSAGE : errorMessage;
};
export const errorHandler = (e, showErr) => {
    let error;
    if (e.response) {
        error = {
            status: e.response?.status,
            data: e.response?.data || { errors: [{ text: e.message }] },
        };
    }
    else {
        error = {
            status: 0,
            data: { errors: [{ text: e.message, propertyName: "", errorType: ErrorType.Unknown }] },
        };
    }
    if (showErr) {
        showToaster(handleErrorMessage(error.data.errors[0].text));
    }
    throw error;
};
